import { CanDeactivateFn } from '@angular/router';

export interface NuevaAgendaFlowExitAware {
  confirmExitFlow(nextUrl: string | null): boolean | Promise<boolean>;
}

export const nuevaAgendaFlowExitGuard: CanDeactivateFn<NuevaAgendaFlowExitAware> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => component.confirmExitFlow(nextState?.url ?? null);
